import { gql } from '@apollo/client';
import ErrorResultFragment from "../../fragments/ErrorResult";

const UPDATE_WORKSPACE_DASHBOARD = gql`
  mutation UpdateWorkspaceDashboard(
    $id: Int
    $filter: DashboardType!
    $route: String
    $jsonContent: String
    $dashboardSettings: DashboardSettingsInput!
  ) {
    dashboardContext {
      updateWorkspaceDashboard(
        id: $id
        filter: $filter
        route: $route
        jsonContent: $jsonContent
        dashboardSettings: $dashboardSettings
      ) {
        errorResult {
          ...ErrorResultFields
        }
        success
      }
    }
  }
  ${ErrorResultFragment}
`;

export default UPDATE_WORKSPACE_DASHBOARD;
